<template>
    <el-popover class="approval-pop" trigger="hover" placement="top" popper-class="approval-popper">
        <template>
            <el-table
                ref="approvalDetailTable"
                :show-header="false"
                :data="approvalTableData"
                style="width: 100%">
                    <el-table-column
                        prop="approvalDetail"
                        width="680"
                        >
                        <template slot-scope="scope">
                            <el-steps v-if="scope.row.approvalMethod != 2 && scope.row.approvalTotalNum>0" align-center finish-status="success">
                                <el-step v-for="(item, index) in scope.row.users" :class="activeClass(item)" :key="index" :title="item.trueName" :description="item.hasOwnProperty('approvalRemarks')?item.approvalRemarks:''"></el-step>
                            </el-steps>
                            <el-steps v-if="scope.row.approvalMethod == 2 && scope.row.approvalTotalNum>0" align-center finish-status="success">
                                <el-step v-for="(item, index) in scope.row.approVoList" :class="activeClass(item)" :key="index" align-center :description="item.hasOwnProperty('approvalRemarks')?item.approvalRemarks:''">
                                    <el-breadcrumb v-if="item && item.list.length > 0" slot="title" :separator="(scope.row.approvalUserGroupList[index].approvalMultiSignType == 2?'+':'/')">
                                        <el-breadcrumb-item  v-for="(user, i) in item.list" :key="i" :class="activeUserClass(user)">{{user.trueName}}</el-breadcrumb-item>
                                    </el-breadcrumb>
                                </el-step>
                            </el-steps>
                        </template>
                    </el-table-column>
            </el-table>
        </template>
        <div v-if="!isStatus" slot="reference" class="approvalName-wrapper">{{ cellValue }}</div>
        <div v-if="isStatus" slot="reference" class="approvalName-wrapper">
            <template>
                <el-tag type="info" v-if="cellValue==0" round>草稿</el-tag>
                <el-tag type="primary" v-if="cellValue==1" round>审批中</el-tag>
                <el-tag size="mini" type="success" v-if="cellValue==2" round>通过</el-tag>
                <el-tag size="mini" type="danger"  v-if="cellValue==3" round>驳回</el-tag>
            </template>
        </div>
    </el-popover>
</template>

<script>
    export default {
        data () {
            return {
            };
        },
        props: {
            isShowOverflowTooltip: {
                type: Boolean,
                default: false
            },
            column: {
                type: Object
            },
            cellValue: {
                type: [String, Number],
                default: ''
            },
            approvalTableData: { // 列表数据
                type: Array
            },
            tableColumns: { // 列表中需要显示的字段
                type: Array
            },
            isStatus: {
                type: Boolean,
                default: false
            }
        },
        created () {
    
        },
        methods: {
            activeClass (item) {
                if (item.stepStatus === 1) {
                    return 'success-step';
                } else if (item.stepStatus === 2) {
                    return 'reject-step';
                } else if (item.stepStatus === 99) {
                    return 'now-step';
                } else {
                    return '';
                }
            },
            activeUserClass (item) {
                if (item.stepStatus === 1) {
                    return 'success-user';
                } else if (item.stepStatus === 2) {
                    return 'reject-user';
                } else if (item.stepStatus === 99) {
                    return 'now-user';
                } else {
                    return '';
                }
            }
        }
    };
</script>

<style lang="less">
    .approval-pop{
        .approvalName-wrapper{
            white-space: nowrap;
        }
    }
    .el-popover&.approval-popper {
        .el-step__main .el-breadcrumb{
            display: inline-block;
        }
        .success-step{
          .el-step__head{
              color: #67c23a;
              border-color: #67c23a; 
              .is-success{
                color: #67c23a;
                border-color: #67c23a; 
              }
          }
          .el-breadcrumb__inner{
                color: #c0c4cc;
                .is-success{
                    color: #67c23a;
                    border-color: #67c23a; 
                }
           }
           .success-user .el-breadcrumb__inner{
               color: #67c23a;
           }
          .el-step__title{
              color: #67c23a;
          }
          .el-step__description{
              color: #303133;
          }
          .el-step__line {
            position: absolute;
            border-color: inherit;
            background-color: #67c23a;
            color: #67c23a;
          }
        }
        .reject-step{
          .el-step__head{
              color: #f56c6c;
              border-color: #f56c6c; 
          }
           .el-breadcrumb__inner{
                color: #c0c4cc;
           }
           .reject-user .el-breadcrumb__inner{
               color: #f56c6c;
           }
          .el-step__title{
              color: #f56c6c;
          }
          .el-step__description{
              color: #303133;
          }
        }
        .now-step{
          .el-step__head{
              color: #409eff;
              border-color: #409eff; 
              .is-success{
                color: #409eff;
                border-color: #409eff; 
              }
          }
          .el-breadcrumb__inner{
                color: #409eff;
                border-color: #409eff; 
                .is-success{
                    color: #409eff;
                    border-color: #409eff; 
                }
            }
          .el-step__title{
              color: #409eff;
              .is-process{
                font-weight: 700;
              }
          }
          .el-step__line {
            position: absolute;
            border-color: inherit;
            background-color: #409eff;
            color: #409eff;
          }
        }
        .success-user .el-breadcrumb__inner{
            color: #67c23a;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/DynamicTable/DynamicApprovalColumn.vue